import Vue from 'vue'
import VueRouter from 'vue-router'

//const ShopIndex = () => import("@/view/shop/Index");
import Index from '@/view/index/Index';
import Login from '@/view/account/Login';
import Register from '@/view/account/Register';
import Forget from '@/view/account/Forget';
import Password from '@/view/account/Password';
import loginRouter from '@/view/account/Router';

Vue.use(VueRouter);
export default new VueRouter({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/account/login',
            name: 'Login',
            component: Login,
            meta: {
                title: '',
                type: 'loginJump'
            }
        },
        {
            path: '/account/register',
            name: 'Register',
            component: Register,
            meta: {
                title: '注册'
            }
        },
        {
            path: '/account/forget',
            name: 'Forget',
            component: Forget,
            meta: {
                title: '找回密码'
            }
        },
        {
            path: '/account/password',
            name: 'Password',
            component: Password,
            meta: {
                title: '修改密码',
                type: 'login'
            }
        },
        {
            path: '/account/router',
            name: 'accountRouter',
            component: loginRouter,
            meta: {
                title: '正在跳转'
            }
        }
    ]
});